import businessClient from 'src/services/clients/business'
import { IMeta, IInventoryLocation } from 'src/common/interfaces/index.js'

const ISettingsInventoryLocationResponse = { meta: IMeta, date: { list: [IInventoryLocation] } }

export const settingsInventoryLocation = {
  /**
   * @param {{store_id: number}} filter
   * @return {ISettingsInventoryLocationResponse}
   */
  list(filter, signal) {
    return businessClient().post('inventory/location/portal/list', { filter }, { signal })
  },

  /**
   * @param {IInventoryLocation} data
   * @return {upsert: [IInventoryLocation]}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/location/upsert', { data }, { signal })
  },

  /**
   * @param {store_id: number; id: number} filter
   * @return {ISettingsInventoryLocationResponse}
   */
  archive(filter, signal) {
    return businessClient().post('inventory/location/archive', { filter }, { signal })
  },
}
